if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.zoomScale = 1;
        this.zoomX = 0;
        this.zoomY = 0;
        this.zoomPointers = new Map();

        this.addEventListener('pointerdown', this.onZoomPointerDown.bind(this));
        this.addEventListener('pointermove', this.onZoomPointerMove.bind(this));
        this.addEventListener('pointerup', this.onZoomPointerEnd.bind(this));
        this.addEventListener('pointercancel', this.onZoomPointerEnd.bind(this));
      }

      hide() {
        this.resetMobileZoom();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        this.zoomImage = null;
        this.resetMobileZoom();

        if (this.mobileZoomEnabled() && activeMedia.nodeName === 'IMG') {
          this.zoomImage = activeMedia;
          container.scrollTop = 0;
          container.scrollLeft = 0;
        } else {
          activeMedia.scrollIntoView();
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      mobileZoomEnabled() {
        return this.dataset.mobileZoom === 'true' && window.matchMedia('(max-width: 749px)').matches;
      }

      onZoomPointerDown(event) {
        if (!this.zoomImage || event.target !== this.zoomImage || !this.mobileZoomEnabled()) return;

        this.zoomImage.setPointerCapture(event.pointerId);
        this.zoomPointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        this.zoomImage.classList.add('is-zooming');

        if (this.zoomPointers.size === 2) {
          const points = [...this.zoomPointers.values()];
          this.pinchStartDistance = this.pointerDistance(points);
          this.pinchStartScale = this.zoomScale;
        } else {
          this.panStartX = event.clientX;
          this.panStartY = event.clientY;
          this.panOriginX = this.zoomX;
          this.panOriginY = this.zoomY;
        }
      }

      onZoomPointerMove(event) {
        if (!this.zoomImage || !this.zoomPointers.has(event.pointerId)) return;

        event.preventDefault();
        this.zoomPointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

        if (this.zoomPointers.size === 2) {
          const points = [...this.zoomPointers.values()];
          const distance = this.pointerDistance(points);
          const maxScale = Number.parseFloat(this.dataset.mobileZoomMax) || 4;
          this.zoomScale = Math.min(maxScale, Math.max(1, this.pinchStartScale * (distance / this.pinchStartDistance)));
          this.constrainZoomPosition();
        } else if (this.zoomScale > 1) {
          this.zoomX = this.panOriginX + event.clientX - this.panStartX;
          this.zoomY = this.panOriginY + event.clientY - this.panStartY;
          this.constrainZoomPosition();
        }

        this.applyMobileZoom();
      }

      onZoomPointerEnd(event) {
        if (!this.zoomImage || !this.zoomPointers.has(event.pointerId)) return;

        this.zoomPointers.delete(event.pointerId);

        if (this.zoomPointers.size === 1) {
          const point = [...this.zoomPointers.values()][0];
          this.panStartX = point.x;
          this.panStartY = point.y;
          this.panOriginX = this.zoomX;
          this.panOriginY = this.zoomY;
        } else if (this.zoomPointers.size === 0) {
          this.zoomImage.classList.remove('is-zooming');
          if (this.zoomScale <= 1.01) this.resetMobileZoom();
        }
      }

      pointerDistance(points) {
        return Math.hypot(points[0].x - points[1].x, points[0].y - points[1].y);
      }

      constrainZoomPosition() {
        if (!this.zoomImage || this.zoomScale <= 1) {
          this.zoomX = 0;
          this.zoomY = 0;
          return;
        }

        const maxX = (this.zoomImage.clientWidth * (this.zoomScale - 1)) / 2;
        const maxY = (this.zoomImage.clientHeight * (this.zoomScale - 1)) / 2;
        this.zoomX = Math.min(maxX, Math.max(-maxX, this.zoomX));
        this.zoomY = Math.min(maxY, Math.max(-maxY, this.zoomY));
      }

      applyMobileZoom() {
        if (!this.zoomImage) return;
        this.zoomImage.style.transform = `translate3d(${this.zoomX}px, ${this.zoomY}px, 0) scale(${this.zoomScale})`;
        this.zoomImage.classList.toggle('is-zoomed', this.zoomScale > 1.01);
      }

      resetMobileZoom() {
        this.zoomPointers.clear();
        this.zoomScale = 1;
        this.zoomX = 0;
        this.zoomY = 0;

        if (!this.zoomImage) return;
        this.zoomImage.style.transform = '';
        this.zoomImage.classList.remove('is-zoomed', 'is-zooming');
      }
    }
  );
}
